import Vue from "vue";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
    faFacebook,
    faYoutube,
    faTwitter,
    faInstagram
} from "@fortawesome/free-brands-svg-icons";

import {
    faChevronDown,
    faChevronRight,
    faCog,
    faTimes,
    faSignOutAlt,
    faSpinner,
    faTimesCircle,
    faArrowCircleLeft
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faChevronDown,
    faChevronRight,
    faCog,
    faTimes,
    faFacebook,
    faYoutube,
    faTwitter,
    faInstagram,
    faSignOutAlt,
    faSpinner,
    faTimesCircle,
    faArrowCircleLeft
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
